import { SET_AUTH, LOGOUT } from './types'

const initialState = {
  auth: {},
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_AUTH:
      return {
        ...state,
        auth: { ...state.auth, ...action.payload },
      }

    case LOGOUT:
      return { ...state, auth: {} }

    default:
      return state
  }
}
export default reducer
